// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__iHgRs","signatureButtonsRight":"ModalSign_signatureButtonsRight__3k4dH"};